const textProps = {
  title: "Not just clothes, but a lifestyle",
  subtitle:
    "This is the best way to find your favorite stuff. Don't forget all these items are unique pieces hand-crafted by people.",
  image: require("assets/img/pages/product-cover.jpg").default,
  skewColor: "white",
};
export default textProps;
